import { parseDefinition, type Definition } from "@ax-shindan/core";
import rawLocal from "@ax-shindan/core/definition";

export type LoadedDefinition = {
  definition: Definition;
  questionSetId: string;
  source: "local" | "firestore";
};

/**
 * 設問定義のロード。— 仕様書 §3.1
 * P1: ローカルJSONで駆動（バックエンド不要で設問レビューを回せる）。
 * P2以降: config/app.publishedSetId → questionSets/{id} を読む（下の firestore 分岐）。
 *
 * VITE_USE_FIRESTORE=1 かつ Firebase設定があるときのみFirestoreを試み、
 * それ以外はバンドル済みローカル定義にフォールバックする。
 */
export async function loadDefinition(previewSetId?: string): Promise<LoadedDefinition> {
  const useFirestore = import.meta.env.VITE_USE_FIRESTORE === "1";
  if (useFirestore) {
    try {
      const { loadFromFirestore } = await import("./firestore.js");
      return await loadFromFirestore(previewSetId);
    } catch (e) {
      console.warn("[loadDefinition] Firestore取得に失敗、ローカル定義にフォールバック", e);
    }
  }
  const definition = parseDefinition(rawLocal);
  return { definition, questionSetId: definition.version ?? "local", source: "local" };
}
